import styled from 'styled-components';
import { motion } from 'framer-motion';
import fonts from '../../design-system/fonts';
import colors from '../../design-system/colors';

export const Section = styled(motion.section)`
  padding: 46px 40px;
  background: #fff;

  @media (max-width: 768px) {
    padding: 46px 20px;
  }
`;

export const Container = styled.div`
  margin: 0px auto;
`;

export const TopSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 80px;
  gap: 80px;
  align-items: start;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    margin-bottom: 0px;
    gap: 0px;
  }
  @media (max-width: 768px) {
    margin-bottom: 0px;
    gap: 0px;
  }
`;

export const BottomSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: start;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  @media (max-width: 480px) {
    gap: 20px;
  }
`;

export const LeftColumn = styled(motion.div)`
  display: flex;
  flex-direction: column;
`;

export const RightColumn = styled(motion.div)`
  display: flex;
  flex-direction: column;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
`;

export const Title = styled(motion.div)`
  font-size: 20px;
  color: ${colors.deepCharcoal};
  margin: 0;
  margin-bottom: 20px;
  letter-spacing: -0.03em;
  line-height: 30px;
  font-family: ${fonts.headline};
  text-transform: uppercase;

  @media (max-width: 1024px) {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 480px) {
    font-size: 22px;
  }
`;

export const Description = styled(motion.p)`
  font-size: 23px;
  color: ${colors.deepCharcoal};
  line-height: 1.3;
  margin: 0;
  text-align: right;
  font-style: normal;
  font-weight: 500;
  text-transform: capitalize;
  font-family: ${fonts.headline};
  margin-bottom: 20px;
  -webkit-text-stroke: 0.3px currentColor;
  .strong-title {
    font-size: 25px;
  }
  @media (max-width: 1024px) {
    font-size: 23px;
    margin-bottom: 20px;
    text-align: left;
    .strong-title {
      font-size: 25px;
    }
  }

  @media (max-width: 768px) {
    font-size: 19px;
    .strong-title {
      font-size: 21px;
    }
  }
  @media (max-width: 480px) {
    font-size: 17px;
    .strong-title {
      font-size: 19px;
    }
  }
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Card = styled(motion.div)`
  border-top: 1px solid #e0e0e0;
  padding-top: 24px;
  padding-bottom: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  &:first-child {
    border: none;
  }
  @media (max-width: 768px) {
    padding-top: 16px;
    padding-bottom: 16px;
  }
  @media (max-width: 480px) {
    padding-top: 12px;
    padding-bottom: 12px;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CardTitle = styled(motion.h3)`
  font-size: 18px;
  font-weight: 500;
  color: #000;
  margin: 0;
  letter-spacing: -0.01em;
  font-family: ${fonts.headline};
  transition: color 0.3s ease;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const ToggleIcon = styled(motion.div)`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #000;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  flex-shrink: 0;
  transition: all 0.3s ease;
`;

export const CardContent = styled(motion.div)`
  overflow: hidden;
  margin-top: 16px;
`;

export const CardText = styled(motion.p)`
  font-size: 16px;
  color: ${colors.deepCharcoal};
  opacity: 0.7;
  line-height: 1.6;
  margin: 0;
  font-family: ${fonts.body};

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const ImagesContainer = styled.div`
  display: flex;
  gap: 24px;
`;

export const ImageWrapper = styled(motion.div)`
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
`;

export const SmallImage = styled(ImageWrapper)`
  aspect-ratio: 1;
  max-width: 400px;
  align-self: flex-start;
  position: relative;
`;

export const LargeImage = styled(ImageWrapper)`
  aspect-ratio: 3.5 / 4;
  align-self: flex-end;
  position: relative;
`;

export const Image = styled(motion.img)`
  width: 100%;
  height: 100%;
  object-fit: fill;
  position: absolute;
  top: 0;
  left: 0;
`;

export const ImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
  font-family: ${fonts.body};
`;
